"use client";
import PropertiesNavigate from "./PropertiesNavigate";
import { useLocale } from "next-intl";
import PropertiesInfo from "./PropertiesInfo";
import { useGetPropertyDetails } from "@/hooks/main-hook";
import PropertyDetailsSkeleton from "../loading/PropertyDetailsSkeleton";
import Link from "next/link";
import AIToolsHub from "./AIToolsHub";
import AskPropertyChat from "./AskPropertyChat";
import AudioSummary from "./AudioSummary";
import DayInLife from "./DayInLife";

export default function PropertiesDetails({ slug }: { slug?: string }) {
  const locale = useLocale();

  const {
    data: propertyData,
    isLoading,
    isError,
  } = useGetPropertyDetails(slug);

  const data = propertyData?.property;
  const name =
    locale === "en"
      ? data?.title_en || "No Title"
      : data?.title_ar || "لا عنوان";

  

  return (
    <div className="sm:container px-4 md:px-0 lg:w-[85%] mx-auto mt-8">
      {isLoading ? (
        <PropertyDetailsSkeleton />
      ) : (
        <>
          <PropertiesNavigate name={name} />
          {!isError && data ? (
            <>
              <PropertiesInfo data={data} />
              <AIToolsHub />

              <div id="ai-audio">
                <AudioSummary slug={slug} />
              </div>
              <div id="ai-day">
                <DayInLife
                  slug={slug}
                  title={name}
                  images={
                    data?.images?.length ? data.images : data?.thumbnail ? [data.thumbnail] : []
                  }
                />
              </div>
              <div id="ai-ask">
                <AskPropertyChat slug={slug} title={name} />
              </div>
            </>
          ) : (
            <div className="flex flex-col justify-center items-center h-60">
              <h2 className="text-2xl font-semibold">
                {locale === "ar"
                  ? "العقار غير متوفر"
                  : "Property not available"}
              </h2>
              <Link
                href="/properties"
                className="bg-main mt-4 text-white px-4 py-2 rounded-lg"
              >
                {locale === "ar" ? "عودة إلى العقارات" : "Back to Properties"}
              </Link>
            </div>
          )}
        </>
      )}
    </div>
  );
}
